import { toggledToolNames, ToggledToolNames, ToolNames } from '@/shared/config';

export const isToggledTool = (
  control: ToolNames,
): control is ToggledToolNames =>
  [...toggledToolNames].includes(control as ToggledToolNames);
